const badgeVariants = {
  default: "bg-primary text-primary-foreground",
  secondary: "bg-secondary text-secondary-foreground",
  destructive: "bg-destructive/20 text-destructive",
  success: "bg-success/20 text-success",
  warning: "bg-warning/20 text-warning",
  outline: "border border-border text-foreground",
}

export function Badge({ className = "", variant = "default", children, ...props }) {
  return (
    <span
      className={`
        inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium
        ${badgeVariants[variant]}
        ${className}
      `}
      {...props}
    >
      {children}
    </span>
  )
}
